import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { injectSchema, getLocalBusinessSchema, getWebPageSchema } from '../../utils/seo';

export default function Home() {
  useEffect(() => {
    // Inject Schema.org structured data
    const schemas = [
      getLocalBusinessSchema(),
      getWebPageSchema(
        'Spark\'Up - Nettoyage haut de gamme de canapés à Lausanne',
        'Service professionnel de nettoyage de canapés, fauteuils et matelas à domicile à Lausanne. Résultats immédiats. Devis gratuit.'
      )
    ];
    
    injectSchema(schemas);
  }, []);

  const testimonials = [
    {
      name: "Tony Dubusc",
      location: "Lausanne",
      rating: 5,
      text: "Enfin une entreprise sérieuse ! Merci pour ma flotte de véhicules. Travail professionnel avec des tarifs très concurrentiel. À très vite"
    },
    {
      name: "Audrey",
      location: "Pully",
      rating: 5,
      text: "Incroyable la différence! Je recommande"
    },
    {
      name: "Caroline Roux",
      location: "Renens",
      rating: 5,
      text: "Travail très bien effectué\nRapide et méticuleux\nJe recommande !"
    },
    {
      name: "Marylaure",
      location: "Morges",
      rating: 5,
      text: "Merci pour votre travail le top du top"
    }
  ];

  const features = [
    {
      icon: "ri-time-line",
      title: "Intervention rapide",
      description: "Disponibilité sous 48h dans tout le Canton de Vaud"
    },
    {
      icon: "ri-eye-line",
      title: "Résultats visibles",
      description: "Transformation immédiate de vos tissus et meubles"
    },
    {
      icon: "ri-shield-check-line",
      title: "Professionnels certifiés",
      description: "Produits et techniques certifiés pour tous types de tissus"
    },
    {
      icon: "ri-tools-line",
      title: "Équipement haut de gamme",
      description: "Shampouineuse professionnelle et matériel de pointe"
    }
  ];

  const beforeAfter = [
    {
      before: "https://public.readdy.ai/ai/img_res/6fda1199c2df9b019be44ca65750e400.jpg",
      after: "https://readdy.ai/api/search-image?query=clean%20pristine%20fresh%20fabric%20sofa%20couch%20perfectly%20cleaned%20beige%20upholstery%20spotless%20surface%20in%20bright%20living%20room%20interior%20after%20professional%20cleaning%20high%20quality%20photography%20realistic%20detailed%20texture%20looking%20brand%20new&width=600&height=400&seq=ba2&orientation=landscape",
      title: "Canapé en tissu"
    },
    {
      before: "https://readdy.ai/api/search-image?query=worn%20dirty%20leather%20sofa%20with%20stains%20marks%20and%20dull%20surface%20dark%20brown%20upholstery%20in%20living%20room%20before%20cleaning%20professional%20photography%20realistic%20detailed%20texture%20showing%20age%20and%20dirt&width=600&height=400&seq=ba3&orientation=landscape",
      after: "https://readdy.ai/api/search-image?query=restored%20clean%20shiny%20leather%20sofa%20perfectly%20conditioned%20dark%20brown%20upholstery%20gleaming%20surface%20in%20living%20room%20after%20professional%20cleaning%20and%20treatment%20high%20quality%20photography%20realistic%20looking%20renewed&width=600&height=400&seq=ba4&orientation=landscape",
      title: "Canapé en cuir"
    },
    {
      before: "https://readdy.ai/api/search-image?query=stained%20dirty%20mattress%20with%20visible%20spots%20marks%20and%20discoloration%20white%20fabric%20surface%20before%20cleaning%20professional%20photography%20realistic%20detailed%20texture%20showing%20stains%20and%20wear&width=600&height=400&seq=ba5&orientation=landscape",
      after: "https://readdy.ai/api/search-image?query=pristine%20clean%20white%20mattress%20perfectly%20sanitized%20spotless%20fabric%20surface%20after%20professional%20deep%20cleaning%20high%20quality%20photography%20realistic%20detailed%20texture%20looking%20brand%20new%20fresh%20hygienic&width=600&height=400&seq=ba6&orientation=landscape",
      title: "Matelas"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm sticky top-0 z-50 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/39f01b0f1c683637cd8f53dc045bcf45/b7bb771b8d681dae1702525950b7e60d.png" 
                alt="Spark'Up Logo" 
                className="h-16 w-auto"
              />
            </Link>
            <div className="hidden md:flex space-x-10">
              <Link to="/" className="text-navy font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-sky">
                Accueil
              </Link>
              <Link to="/services" className="text-gray-600 hover:text-navy font-medium transition-colors whitespace-nowrap cursor-pointer">
                Services
              </Link>
              <Link to="/processus" className="text-gray-600 hover:text-navy font-medium transition-colors whitespace-nowrap cursor-pointer">
                Processus
              </Link>
              <Link to="/a-propos" className="text-gray-600 hover:text-navy font-medium transition-colors whitespace-nowrap cursor-pointer">
                À propos
              </Link>
              <Link to="/contact" className="text-gray-600 hover:text-navy font-medium transition-colors whitespace-nowrap cursor-pointer">
                Contact
              </Link>
            </div>
            <Link to="/contact" className="bg-navy text-white px-8 py-3 rounded-full font-semibold hover:bg-navy-dark transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              Devis gratuit
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-premium-gray via-white to-sky/5 py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <div className="inline-block">
                <span className="text-sky font-semibold text-sm tracking-wider uppercase">Service Premium</span>
              </div>
              <h1 className="text-5xl lg:text-7xl font-bold text-navy leading-tight">
                Redonne vie à ton canapé
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed font-light">
                Nettoyage haut de gamme de canapés et tissus à domicile – résultats immédiats
              </p>
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Link to="/contact" className="bg-navy text-white px-10 py-4 rounded-full font-semibold text-lg hover:bg-navy-dark transition-all shadow-xl hover:shadow-2xl text-center whitespace-nowrap cursor-pointer">
                  Demander un devis gratuit
                </Link>
                <a href="tel:+41782036539" className="bg-white text-navy border-2 border-navy px-10 py-4 rounded-full font-semibold text-lg hover:bg-navy hover:text-white transition-all text-center whitespace-nowrap cursor-pointer">
                  Appeler maintenant
                </a>
              </div>
            </div>
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-sky/20 to-navy/20 rounded-3xl blur-2xl"></div>
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20upholstery%20cleaning%20service%20worker%20using%20industrial%20steam%20cleaner%20machine%20on%20elegant%20modern%20fabric%20sofa%20in%20bright%20contemporary%20living%20room%20interior%20high%20quality%20photography%20realistic%20detailed%20showing%20cleaning%20process%20in%20action%20professional%20equipment&width=800&height=600&seq=hero1&orientation=landscape"
                alt="Nettoyage professionnel de canapé"
                className="relative rounded-3xl shadow-2xl w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <span className="text-sky font-semibold text-sm tracking-wider uppercase mb-4 block">Excellence</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-navy mb-6">
              Pourquoi choisir Spark'Up ?
            </h2>
            <p className="text-xl text-gray-600 font-light max-w-2xl mx-auto">
              Un service professionnel qui fait la différence
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-premium-gray p-8 rounded-2xl text-center hover:shadow-xl transition-all group">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-sky to-navy text-white rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${feature.icon} text-3xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-navy mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 font-light leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Before/After Gallery */}
      <section className="py-24 bg-premium-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <span className="text-sky font-semibold text-sm tracking-wider uppercase mb-4 block">Résultats</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-navy mb-6">
              Avant / Après
            </h2>
            <p className="text-xl text-gray-600 font-light">
              Des résultats qui parlent d'eux-mêmes
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {beforeAfter.map((item, index) => (
              <div key={index} className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all">
                <div className="relative">
                  <div className="absolute top-6 left-6 bg-navy/90 text-white px-5 py-2 rounded-full font-semibold text-sm z-10 whitespace-nowrap">
                    Avant
                  </div>
                  <img 
                    src={item.before}
                    alt={`Avant nettoyage ${item.title}`}
                    className="w-full h-64 object-cover object-top"
                  />
                </div>
                <div className="relative">
                  <div className="absolute top-6 left-6 bg-sky text-white px-5 py-2 rounded-full font-semibold text-sm z-10 whitespace-nowrap">
                    Après
                  </div>
                  <img 
                    src={item.after}
                    alt={`Après nettoyage ${item.title}`}
                    className="w-full h-64 object-cover object-top"
                  />
                </div>
                <div className="p-8 text-center">
                  <h3 className="text-xl font-bold text-navy">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <span className="text-sky font-semibold text-sm tracking-wider uppercase mb-4 block">Témoignages</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-navy mb-6">
              Avis de nos clients
            </h2>
            <p className="text-xl text-gray-600 font-light">
              La satisfaction de nos clients est notre priorité
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-premium-gray p-8 rounded-3xl shadow-md hover:shadow-xl transition-all">
                <div className="flex mb-6">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                  ))}
                </div>
                <p className="text-gray-700 mb-6 leading-relaxed font-light">
                  "{testimonial.text}"
                </p>
                <div className="border-t border-gray-200 pt-6">
                  <p className="font-bold text-navy">{testimonial.name}</p>
                  <p className="text-sm text-gray-500 font-light">{testimonial.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-24 bg-gradient-to-br from-navy to-navy-dark text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-sky font-semibold text-sm tracking-wider uppercase mb-4 block">Avantages</span>
              <h2 className="text-4xl lg:text-5xl font-bold mb-12">
                Pourquoi choisir Spark'Up ?
              </h2>
              <div className="space-y-8">
                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-2xl flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-3xl text-sky"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Professionnalisme garanti</h3>
                    <p className="text-white/80 font-light leading-relaxed">Équipe formée et certifiée pour tous types de tissus et matériaux</p>
                  </div>
                </div>
                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-2xl flex-shrink-0">
                    <i className="ri-timer-flash-line text-3xl text-sky"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Rapidité d'intervention</h3>
                    <p className="text-white/80 font-light leading-relaxed">Disponibilité sous 48h dans tout le Canton de Vaud</p>
                  </div>
                </div>
                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-2xl flex-shrink-0">
                    <i className="ri-heart-line text-3xl text-sky"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Satisfaction garantie</h3>
                    <p className="text-white/80 font-light leading-relaxed">Résultats visibles immédiatement ou nous revenons gratuitement</p>
                  </div>
                </div>
                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-2xl flex-shrink-0">
                    <i className="ri-leaf-line text-3xl text-sky"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Produits écologiques</h3>
                    <p className="text-white/80 font-light leading-relaxed">Solutions de nettoyage respectueuses de l'environnement et de votre santé</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white/5 backdrop-blur-sm p-12 rounded-3xl border border-white/10">
              <h3 className="text-3xl font-bold mb-6">Prêt à redonner vie à vos meubles ?</h3>
              <p className="text-xl text-white/80 mb-10 font-light leading-relaxed">
                Obtenez un devis gratuit en moins de 24h. Sans engagement.
              </p>
              <Link to="/contact" className="bg-white text-navy px-10 py-4 rounded-full font-semibold text-lg hover:bg-premium-gray transition-all inline-block whitespace-nowrap cursor-pointer shadow-xl">
                Demander un devis gratuit
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-navy mb-6">
            Transformez vos meubles dès aujourd'hui
          </h2>
          <p className="text-xl text-gray-600 mb-10 font-light">
            Intervention rapide à Lausanne et dans tout le Canton de Vaud
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="bg-navy text-white px-10 py-4 rounded-full font-semibold text-lg hover:bg-navy-dark transition-all shadow-xl whitespace-nowrap cursor-pointer">
              Obtenir un devis gratuit
            </Link>
            <Link to="/services" className="bg-premium-gray text-navy px-10 py-4 rounded-full font-semibold text-lg hover:bg-gray-200 transition-all whitespace-nowrap cursor-pointer">
              Découvrir nos services
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-navy text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-12 mb-16">
            <div>
              <img 
                src="https://static.readdy.ai/image/39f01b0f1c683637cd8f53dc045bcf45/b7bb771b8d681dae1702525950b7e60d.png" 
                alt="Spark'Up Logo" 
                className="h-12 w-auto mb-6"
              />
              <p className="text-white/70 mb-6 font-light leading-relaxed">
                Nettoyage professionnel de canapés et tissus à Lausanne
              </p>
              <div className="flex gap-4">
                <a href="https://share.google/v4Ro6xy2LeuVbtJiq" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full hover:bg-sky transition-all cursor-pointer">
                  <i className="ri-google-fill text-xl"></i>
                </a>
                <a href="https://www.instagram.com/sparkup.swiss/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full hover:bg-sky transition-all cursor-pointer">
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-6">Navigation</h4>
              <ul className="space-y-3">
                <li><Link to="/" className="text-white/70 hover:text-white transition-colors cursor-pointer font-light">Accueil</Link></li>
                <li><Link to="/services" className="text-white/70 hover:text-white transition-colors cursor-pointer font-light">Services</Link></li>
                <li><Link to="/processus" className="text-white/70 hover:text-white transition-colors cursor-pointer font-light">Processus</Link></li>
                <li><Link to="/a-propos" className="text-white/70 hover:text-white transition-colors cursor-pointer font-light">À propos</Link></li>
                <li><Link to="/contact" className="text-white/70 hover:text-white transition-colors cursor-pointer font-light">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-6">Services</h4>
              <ul className="space-y-3">
                <li className="text-white/70 font-light">Nettoyage de canapés</li>
                <li className="text-white/70 font-light">Nettoyage de fauteuils</li>
                <li className="text-white/70 font-light">Nettoyage de matelas</li>
                <li className="text-white/70 font-light">Nettoyage de cuir</li>
                <li className="text-white/70 font-light">Nettoyage de tapis</li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-6">Contact</h4>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-sky text-xl flex-shrink-0"></i>
                  <span className="text-white/70 font-light">Lausanne, Canton de Vaud, Suisse</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-phone-line text-sky text-xl"></i>
                  <a href="tel:+41782036539" className="text-white/70 hover:text-white transition-colors cursor-pointer font-light">+41 78 203 65 39</a>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-mail-line text-sky text-xl"></i>
                  <a href="mailto:Sparkup.swiss@gmail.com" className="text-white/70 hover:text-white transition-colors cursor-pointer font-light">Sparkup.swiss@gmail.com</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/10 pt-8 text-center text-white/60 font-light">
            <p>&copy; 2025 Spark'Up. Tous droits réservés. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
